import(/* webpackMode: "eager" */ "/vercel/path0/app/providers.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/prosemirror.css")